<div class="wnl-header">
  <p>
    WNL: Interactive with staff, appropriate judgement for developmental age, no suicidal ideation
    expressed. Mood stable and fitting for situation.
  </p>

  <mat-checkbox [checked]="wnlManager.allWNL" [indeterminate]="wnlManager.someWNL()"
    (change)="wnlManager.setAllWNL($event.checked)">
    All Within Normal Limits
  </mat-checkbox>
</div>

<assessment-row title="Mood">
  <emr-checkbox-group [control]="formGroup().controls.mood" [options]="moodOptions" />
</assessment-row>

<assessment-row title="Suicidal thoughts/expression?">
  <emr-checkbox [control]="formGroup().controls.suicidal" label="Yes" />
</assessment-row>